// src/pages/RegisterPage.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthForm from '../components/AuthForm';
import { useUser } from '../contexts/UserContext';
import CurrencyDropdown from '../components/CurrencyDropdown';

export default function RegisterPage() {
  const { register } = useUser();

  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [currency, setCurrency] = useState('USD');
  const [authProvider, setAuthProvider] = useState('Local');
  const [externalToken, setExternalToken] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  return (
    <AuthForm
      showSocialIcons={false}
      title="Register for Castly"
      image="/login.jpg"
      fields={[
        {
          name: 'email',
          label: 'Email',
          type: 'email',
          value: email,
          onChange: (e) => setEmail(e.target.value),
        },
        {
          name: 'password',
          label: 'Password',
          type: 'password',
          value: password,
          onChange: (e) => setPassword(e.target.value),
        },
        {
          name: 'currency',
          label: 'Currency',
          customElement: (
            <CurrencyDropdown value={currency} onChange={setCurrency} />
          ),
        },
      ]}
      onSubmit={async () => {
        const success = await register(email, password, currency, authProvider, externalToken);
        if (!success) throw new Error("Registration failed");
        return success;
      }}
      onSuccess={() => {
        setError("");
        setSuccessMessage("Success! Please check your email");
      }}
      onFailure={(err) => {
        setSuccessMessage("");
        setError("Something went wrong, please try again");
      }}
      errorMessage={error}
      successMessage={successMessage}
      submitLabel="Register"
      submittingLabel="Registering"
      footerLinks={[
        { href: '/login', label: 'Already have an account? Login' },
      ]}
    >
      {error && <p style={{ color: 'red', marginTop: '8px' }}>{error}</p>}
    </AuthForm>
  );
}
